import React, { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { getCardApplications, assignCardNumber } from '../../../services/cardService';
import api, { BASE_URL } from '../../../services/api';
import { getUser, isAdminUser } from '../../../services/authService';
import { message } from 'antd'; // Add antd message

const CardApplicationsList = ({ showToast }) => {
    const isAdmin = isAdminUser();
    const user = getUser();
    const userRole = (user?.userType || user?.role || '').toLowerCase();
    const isSportsAdmin = userRole === 'sports' || userRole === 'sporsuperadmin';
    
    console.log('User:', user);
    console.log('isAdmin:', isAdmin);
    console.log('isSportsAdmin:', isSportsAdmin);
    const [programTabs, setProgramTabs] = useState([]);
    const [activeProgramTab, setActiveProgramTab] = useState('Pool');
    const [applications, setApplications] = useState([]);
    const [selectedApp, setSelectedApp] = useState(null);
    const [viewDetailsApp, setViewDetailsApp] = useState(null);
    const [fullScreenPhoto, setFullScreenPhoto] = useState(null);
    const [cardNumber, setCardNumber] = useState('');
    const [fitnessCapacity, setFitnessCapacity] = useState(null);
    
    // Edit Contact State
    const [editContactApp, setEditContactApp] = useState(null);
    const [editIdentityNumber, setEditIdentityNumber] = useState('');
    const [editPhone, setEditPhone] = useState('');
    const [editCardNumber, setEditCardNumber] = useState('');
    const [isUpdatingContact, setIsUpdatingContact] = useState(false);
    
    // Pagination & Sorting & Filter State
    const [currentPage, setCurrentPage] = useState(1);
    const [sortOrder, setSortOrder] = useState('newest'); // 'newest' | 'oldest'
    const [searchQuery, setSearchQuery] = useState('');
    const itemsPerPage = 15;

    useEffect(() => {
        resolveProgramTabs();
        loadData();
        loadFitnessCapacity();
    }, []);

    const loadFitnessCapacity = async () => {
        try {
            console.log('Fitness capacity yükleniyor...');
            const response = await api.get('/api/card/fitness-capacity');
            console.log('Fitness capacity raw response:', response);
            if (response?.data) {
                console.log('Fitness Capacity Loaded:', response.data);
                setFitnessCapacity(response.data);
            } else if (response?.male) {
                // API interceptor data'yı unwrap etmiş olabilir
                console.log('Fitness Capacity (direct):', response);
                setFitnessCapacity(response);
            } else {
                console.warn('Fitness capacity beklenmedik format:', response);
            }
        } catch (error) {
            console.error('Fitness kapasite bilgisi alınamadı:', error);
        }
    };

    console.log('Active Tab:', activeProgramTab, 'Fitness Capacity:', fitnessCapacity);

    const handleUpdateContact = async () => {
        if (!editContactApp) return;

        if (!editIdentityNumber || editIdentityNumber.length !== 11) {
            if (showToast) {
                showToast('TC Kimlik numarası 11 haneli olmalıdır.', 'error');
            } else {
                message.error('TC Kimlik numarası 11 haneli olmalıdır.');
            }
            return;
        }

        if (!editPhone) {
            if (showToast) {
                showToast('Telefon numarası zorunludur.', 'error');
            } else {
                message.error('Telefon numarası zorunludur.');
            }
            return;
        }

        setIsUpdatingContact(true);
        try {
            const response = await api.put('/api/card/update-contact', {
                applicationId: editContactApp.id,
                identityNumber: editIdentityNumber,
                phone: editPhone,
                cardNumber: editCardNumber.trim()
            });

            if (response?.isSuccess) {
                const updatedApp = {
                    ...editContactApp,
                    identityNumber: editIdentityNumber,
                    phone: editPhone,
                    cardNumber: editCardNumber.trim() || null
                };
                if (showToast) {
                    showToast('İletişim bilgileri güncellendi.', 'success');
                } else {
                    message.success('İletişim bilgileri güncellendi.');
                }
                setApplications(prev => prev.map(app => app.id === editContactApp.id ? { ...app, ...updatedApp } : app));
                setViewDetailsApp(prev => prev?.id === editContactApp.id ? { ...prev, ...updatedApp } : prev);
                setEditContactApp(null);
                setEditCardNumber('');
                loadData(); // Reload data
            } else {
                if (showToast) {
                    showToast(response?.resultMessage || 'Güncelleme başarısız.', 'error');
                } else {
                    message.error(response?.resultMessage || 'Güncelleme başarısız.');
                }
            }
        } catch (error) {
            console.error('İletişim bilgileri güncellenirken hata:', error);
            const errorMsg = error?.response?.data?.resultMessage || 'İletişim bilgileri güncellenemedi.';
            if (showToast) {
                showToast(errorMsg, 'error');
            } else {
                message.error(errorMsg);
            }
        } finally {
            setIsUpdatingContact(false);
        }
    };

    const normalizeProgramCategory = (programType) => (programType === 'Fitness' ? 'Fitness' : 'Pool');
    const hasAssignedCard = (app) => Boolean((app.cardNumber || '').trim());

    useEffect(() => {
        if (!applications.length) return;

        const availableTabs = Array.from(new Set(applications.map(app => normalizeProgramCategory(app.programType))));

        if (programTabs.length === 0) {
            setProgramTabs(availableTabs);
        }

        if (availableTabs.length > 0 && !availableTabs.includes(activeProgramTab)) {
            setActiveProgramTab(availableTabs[0]);
        }
    }, [applications, activeProgramTab, programTabs.length]);

    const resolveProgramTabs = async () => {
        if (isAdmin) {
            setProgramTabs(['Pool', 'Fitness']);
            setActiveProgramTab('Pool');
            return;
        }

        try {
            const user = getUser();
            const assignedRegionIds = (user?.assignedRegions || []).map(Number);
            if (!assignedRegionIds.length) {
                setProgramTabs([]);
                return;
            }

            const response = await api.get('/api/sports/regions-with-facilities');
            const regions = response?.data || response || [];
            const matchedRegions = regions.filter(region => assignedRegionIds.includes(Number(region.regionId)));

            const hasFitness = matchedRegions.some(region =>
                (region.facilities || []).some(facility => (facility.typeName || '').toLowerCase().includes('fitness'))
            );
            const hasPool = matchedRegions.some(region =>
                (region.facilities || []).some(facility => {
                    const typeName = (facility.typeName || '').toLowerCase();
                    return typeName.includes('havuz') || typeName.includes('pool') || typeName.includes('yuzme') || typeName.includes('yüzme');
                })
            );

            const nextTabs = [];
            if (hasPool) nextTabs.push('Pool');
            if (hasFitness) nextTabs.push('Fitness');
            setProgramTabs(nextTabs);
            setActiveProgramTab(nextTabs[0] || 'Pool');
        } catch (error) {
            console.error('Kart başvuru sekmeleri belirlenemedi:', error);
            setProgramTabs(['Pool', 'Fitness']);
            setActiveProgramTab('Pool');
        }
    };

    // ESC ile modal kapatma
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key !== 'Escape') return;
            if (fullScreenPhoto) { setFullScreenPhoto(null); return; }
            if (viewDetailsApp) { setViewDetailsApp(null); return; }
            if (selectedApp) { setSelectedApp(null); return; }
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [fullScreenPhoto, viewDetailsApp, selectedApp]);

    const loadData = async () => {
        try {
            const res = await getCardApplications();
            if (res.data) setApplications(res.data);
            // Kapasite bilgisini de yenile
            loadFitnessCapacity();
        } catch (error) {
            console.error(error);
        }
    };

    const handleAssign = async () => {
        if (!selectedApp || !cardNumber) return;
        try {
            const res = await assignCardNumber({
                applicationId: selectedApp.id,
                cardNumber,
                programType: selectedApp.programType
            });
            if (res.isSuccess) {
                if (showToast) {
                    showToast('Kart başarıyla atandı!', 'success');
                } else {
                    message.success("Kart atandı!");
                }
                setSelectedApp(null);
                setCardNumber('');
                loadData();
            } else {
                if (showToast) {
                    showToast(res.resultMessage || "Bir hata oluştu.", 'error');
                } else {
                    message.error(res.resultMessage || "Hata oluştu.");
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const filteredApplications = React.useMemo(() => {
        let filtered = programTabs.length > 0
            ? applications.filter(app => normalizeProgramCategory(app.programType) === activeProgramTab)
            : applications;

        // Search Filtering
        if (searchQuery.trim()) {
            const q = searchQuery.trim().toLowerCase();
            filtered = filtered.filter(app =>
                `${app.firstName} ${app.lastName}`.toLowerCase().includes(q) ||
                (app.identityNumber || '').includes(q) ||
                (app.phone || '').includes(q)
            );
        }

        filtered.sort((a, b) => {
            const cardAssignmentDiff = Number(hasAssignedCard(a)) - Number(hasAssignedCard(b));
            if (cardAssignmentDiff !== 0) return cardAssignmentDiff;

            const dateA = new Date(a.createdDate).getTime();
            const dateB = new Date(b.createdDate).getTime();
            return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
        });

        return filtered;
    }, [applications, searchQuery, sortOrder, activeProgramTab, programTabs.length]);

    const paginatedApplications = React.useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredApplications.slice(startIndex, startIndex + itemsPerPage);
    }, [filteredApplications, currentPage]);

    const totalPages = Math.ceil(filteredApplications.length / itemsPerPage);

    // Reset pagination on filter change
    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery, sortOrder, activeProgramTab]);

    const getProgramLabel = (app) => {
        if (app?.programDisplayName) return app.programDisplayName;
        if (app?.programType === 'Fitness') return 'Fitness';
        return 'Havuz';
    };

    const formatDate = (value) => value ? new Date(value).toLocaleDateString('tr-TR') : '-';
    const getMemberships = (app) => Array.isArray(app?.memberships) ? app.memberships : [];
    const getMembershipStatusLabel = (membership) => {
        if (membership?.status === 'Active' && membership?.isCurrent) return 'Aktif';
        if (membership?.status === 'Passive' || membership?.isExpired) return 'Pasif';
        return membership?.status || '-';
    };
    const getMembershipStatusStyle = (membership) => {
        const isActive = membership?.status === 'Active' && membership?.isCurrent;
        return {
            background: isActive ? '#dcfce7' : '#f1f5f9',
            color: isActive ? '#166534' : '#64748b',
            border: `1px solid ${isActive ? '#bbf7d0' : '#cbd5e1'}`
        };
    };
    const getCreditSummary = (app) => {
        const memberships = getMemberships(app);
        const activeRemaining = memberships
            .filter((membership) => membership.status === 'Active' && membership.isCurrent)
            .reduce((sum, membership) => sum + Number(membership.remainingCredits || 0), 0);
        const passiveCount = memberships.filter((membership) => membership.status === 'Passive' || membership.isExpired).length;

        return {
            activeRemaining,
            passiveCount,
            hasMemberships: memberships.length > 0
        };
    };

    return (
        <div className="appointments-list-section card-applications-view">
            <div className="section-header">
                <div className="section-header-left">
                    <h3>Kart Başvuruları</h3>
                    <span className="appointment-count">{filteredApplications.length} Başvuru</span>
                </div>
                <div className="section-header-right">
                    <button className="refresh-button" onClick={loadData}>
                        Yenile
                    </button>
                </div>
            </div>

            {programTabs.length > 0 && (
                <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
                    {programTabs.map((tab) => (
                        <button
                            key={tab}
                            type="button"
                            onClick={() => setActiveProgramTab(tab)}
                            style={{
                                border: activeProgramTab === tab ? '2px solid #2563eb' : '1px solid #cbd5e1',
                                background: activeProgramTab === tab ? '#eff6ff' : '#fff',
                                color: activeProgramTab === tab ? '#1d4ed8' : '#475569',
                                borderRadius: '10px',
                                padding: '10px 16px',
                                fontWeight: '700',
                                cursor: 'pointer'
                            }}
                        >
                            {tab === 'Fitness' ? 'Fitness' : 'Havuz'}
                        </button>
                    ))}
                </div>
            )}

            {/* Fitness Capacity Display */}
            {activeProgramTab === 'Fitness' && fitnessCapacity && (
                <div style={{ 
                    display: 'flex', 
                    gap: '16px', 
                    marginBottom: '16px',
                    padding: '16px',
                    background: '#f8fafc',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0'
                }}>
                    {/* Erkek Kapasite */}
                    <div style={{ flex: 1 }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between',
                            marginBottom: '8px'
                        }}>
                            <span style={{ fontWeight: '600', color: '#475569', fontSize: '14px' }}>
                                Erkek Üye
                            </span>
                            <span style={{ 
                                fontWeight: '700', 
                                fontSize: '16px',
                                color: fitnessCapacity.male.percentage >= 90 ? '#dc2626' : fitnessCapacity.male.percentage >= 75 ? '#f59e0b' : '#10b981'
                            }}>
                                {fitnessCapacity.male.current}/{fitnessCapacity.male.limit}
                            </span>
                        </div>
                        <div style={{ 
                            width: '100%', 
                            height: '8px', 
                            background: '#e2e8f0', 
                            borderRadius: '4px',
                            overflow: 'hidden'
                        }}>
                            <div style={{ 
                                width: `${fitnessCapacity.male.percentage}%`, 
                                height: '100%',
                                background: fitnessCapacity.male.percentage >= 90 ? '#dc2626' : fitnessCapacity.male.percentage >= 75 ? '#f59e0b' : '#10b981',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                        <div style={{ 
                            marginTop: '4px', 
                            fontSize: '12px', 
                            color: '#64748b',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <span>%{fitnessCapacity.male.percentage.toFixed(1)} Dolu</span>
                            <span>{fitnessCapacity.male.available} Kalan</span>
                        </div>
                    </div>

                    {/* Kadın Kapasite */}
                    <div style={{ flex: 1 }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between',
                            marginBottom: '8px'
                        }}>
                            <span style={{ fontWeight: '600', color: '#475569', fontSize: '14px' }}>
                                Kadın Üye
                            </span>
                            <span style={{ 
                                fontWeight: '700', 
                                fontSize: '16px',
                                color: fitnessCapacity.female.percentage >= 90 ? '#dc2626' : fitnessCapacity.female.percentage >= 75 ? '#f59e0b' : '#10b981'
                            }}>
                                {fitnessCapacity.female.current}/{fitnessCapacity.female.limit}
                            </span>
                        </div>
                        <div style={{ 
                            width: '100%', 
                            height: '8px', 
                            background: '#e2e8f0', 
                            borderRadius: '4px',
                            overflow: 'hidden'
                        }}>
                            <div style={{ 
                                width: `${fitnessCapacity.female.percentage}%`, 
                                height: '100%',
                                background: fitnessCapacity.female.percentage >= 90 ? '#dc2626' : fitnessCapacity.female.percentage >= 75 ? '#f59e0b' : '#10b981',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                        <div style={{ 
                            marginTop: '4px', 
                            fontSize: '12px', 
                            color: '#64748b',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <span>%{fitnessCapacity.female.percentage.toFixed(1)} Dolu</span>
                            <span>{fitnessCapacity.female.available} Kalan</span>
                        </div>
                    </div>
                </div>
            )}

            <div className="appointments-filter-bar">
                <div className="filter-search">
                    <input
                        type="text"
                        placeholder="İsim, TC veya Telefon ile ara..."
                        className="filter-search-input"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <select 
                        className="sort-select" 
                        value={sortOrder} 
                        onChange={(e) => setSortOrder(e.target.value)}
                    >
                        <option value="newest">En Yeni Önce</option>
                        <option value="oldest">En Eski Önce</option>
                    </select>
                </div>
            </div>

            <div className="appointments-table-wrapper">
                <table className="appointments-table">
                    <thead>
                        <tr>
                            <th>Ad Soyad</th>
                            <th>Tesis</th>
                            <th>TC</th>
                            <th>Tel</th>
                            <th>Ödenen Ücret</th>
                            <th>Uyelik / Kontor</th>
                            <th>Durum</th>
                            <th>Kart No</th>
                            <th>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedApplications.map(app => (
                            <tr key={app.id}>
                                <td className="name-cell">{app.firstName} {app.lastName}</td>
                                <td>
                                    <span className="status-badge" style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}>
                                        {getProgramLabel(app)}
                                    </span>
                                </td>
                                <td>{app.identityNumber}</td>
                                <td>{app.phone}</td>
                                <td className="payment-cell">
                                    <span className="payment-amount">
                                        {Number(app.paidAmount || 0).toLocaleString('tr-TR')} ₺
                                    </span>
                                </td>
                                <td>
                                    {(() => {
                                        const summary = getCreditSummary(app);
                                        if (!summary.hasMemberships) {
                                            return <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Paket yok</span>;
                                        }

                                        return (
                                            <div style={{ display: 'grid', gap: '4px', minWidth: '120px' }}>
                                                <strong style={{ color: summary.activeRemaining > 0 ? '#166534' : '#b45309', fontSize: '13px' }}>
                                                    {summary.activeRemaining} aktif kontor
                                                </strong>
                                                {summary.passiveCount > 0 && (
                                                    <small style={{ color: '#64748b' }}>{summary.passiveCount} pasif uyelik</small>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </td>
                                <td>
                                    <span className={`status-badge ${app.status?.toLowerCase().replace(/\s+/g, '')}`}>
                                        {app.status}
                                    </span>
                                </td>
                                <td style={{ fontStyle: app.cardNumber ? 'normal' : 'italic', color: app.cardNumber ? 'inherit' : '#94a3b8' }}>
                                    {app.cardNumber || 'Tanımlanmadı'}
                                </td>
                                <td className="appointment-actions">
                                    <button
                                        className="action-button detail"
                                        onClick={() => setViewDetailsApp(app)}
                                        title="Detayları Görüntüle"
                                    >
                                        Detay
                                    </button>
                                    {!app.cardNumber && (
                                        <button
                                            className="action-button transfer"
                                            onClick={() => {
                                                if (!isAdmin) {
                                                    if (showToast) {
                                                        showToast('Bu işlem için yöneticiniz ile görüşün.', 'error');
                                                    } else {
                                                        message.error('Bu işlem için yöneticiniz ile görüşün.');
                                                    }
                                                    return;
                                                }
                                                setSelectedApp(app);
                                            }}
                                            title="Kart Numarası Ata"
                                        >
                                            Kart Tanımla
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {filteredApplications.length === 0 && (
                            <tr>
                                <td colSpan="9" className="no-data">Başvuru bulunamadı.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="pagination-wrapper">
                    <button 
                        className="pagination-btn pagination-nav-btn" 
                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                        title="Önceki Sayfa"
                    >
                        <FaChevronDown style={{ transform: 'rotate(90deg)' }} />
                    </button>
                    
                    <div className="pagination-pages">
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(page => {
                                return page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1;
                            })
                            .map((page, index, array) => (
                                <React.Fragment key={page}>
                                    {index > 0 && array[index - 1] !== page - 1 && <span className="pagination-ellipsis">...</span>}
                                    <button 
                                        className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                    </button>
                                </React.Fragment>
                            ))
                        }
                    </div>

                    <button 
                        className="pagination-btn pagination-nav-btn" 
                        onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                        disabled={currentPage === totalPages}
                        title="Sonraki Sayfa"
                    >
                        <FaChevronRight />
                    </button>
                </div>
            )}

            {/* Card Assignment Modal */}
            {selectedApp && (
                <div className="premium-modal-overlay">
                    <div className="premium-modal card-assignment-modal">
                        <div className="modal-header">
                            <h3>Kart Tanımla</h3>
                            <button className="close-btn" onClick={() => setSelectedApp(null)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="user-info-banner">
                                <div className="user-avatar-mini">
                                    {selectedApp.firstName[0]}{selectedApp.lastName[0]}
                                </div>
                                <div className="user-details-mini">
                                    <span className="user-name">{selectedApp.firstName} {selectedApp.lastName}</span>
                                    <span className="user-id">{selectedApp.identityNumber}</span>
                                </div>
                            </div>
                            
                            <div className="input-group">
                                <label>Kart Numarası</label>
                                <input
                                    type="text"
                                    placeholder="000/0000000"
                                    value={cardNumber}
                                    onChange={(e) => setCardNumber(e.target.value)}
                                    autoFocus
                                />
                                <small>Lütfen fiziksel kartın üzerindeki numarayı giriniz.</small>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn-secondary" onClick={() => setSelectedApp(null)}>İptal</button>
                            <button className="btn-primary" onClick={handleAssign}>Kaydet ve Aktif Et</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Application Detail Modal */}
            {viewDetailsApp && (
                <div className="premium-modal-overlay">
                    <div className="premium-modal detail-modal">
                        <div className="modal-header">
                            <h3 className="modal-title">Başvuru Detayı</h3>
                            <span className="modal-subtitle">Kayıt ID: #{viewDetailsApp.id}</span>
                            <button className="close-btn" onClick={() => setViewDetailsApp(null)}>&times;</button>
                        </div>

                        <div className="modal-content-grid">
                            <div className="modal-sidebar">
                                {viewDetailsApp.photoUrl && (() => {
                                    const photoSrc = viewDetailsApp.photoUrl.startsWith('http') ? viewDetailsApp.photoUrl : `${BASE_URL}${viewDetailsApp.photoUrl.startsWith('/') ? '' : '/'}${viewDetailsApp.photoUrl}`;
                                    return (
                                        <div className="profile-photo-container">
                                            <img
                                                src={photoSrc}
                                                alt="Profil"
                                                className="profile-photo"
                                                onClick={() => setFullScreenPhoto(photoSrc)}
                                            />
                                            <div className="photo-overlay">
                                                <span>Büyütmek için tıklayın</span>
                                            </div>
                                        </div>
                                    );
                                })()}
                                <div className="status-indicator">
                                    <label>Başvuru Durumu</label>
                                    <span className={`status-badge ${viewDetailsApp.status?.toLowerCase().replace(/\s+/g, '')}`}>
                                        {viewDetailsApp.status}
                                    </span>
                                </div>
                            </div>

                            <div className="modal-main-info">
                                <div className="info-grid">
                                    <div className="info-item">
                                        <label>Ad Soyad</label>
                                        <p>{viewDetailsApp.firstName} {viewDetailsApp.lastName}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>TC Kimlik</label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <p style={{ margin: 0 }}>{viewDetailsApp.identityNumber}</p>
                                            {isAdmin && (
                                                <button
                                                    onClick={() => {
                                                        setEditContactApp(viewDetailsApp);
                                                        setEditIdentityNumber(viewDetailsApp.identityNumber);
                                                        setEditPhone(viewDetailsApp.phone);
                                                        setEditCardNumber(viewDetailsApp.cardNumber || '');
                                                    }}
                                                    title="TC, Telefon ve Kart Numarası Düzenle"
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        padding: '4px 12px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        color: '#fff',
                                                        background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                                                        border: 'none',
                                                        borderRadius: '20px',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 2px 6px rgba(99,102,241,0.4)',
                                                        transition: 'all 0.15s ease',
                                                        letterSpacing: '0.01em',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                    onMouseEnter={e => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #4f46e5, #4338ca)';
                                                        e.currentTarget.style.boxShadow = '0 4px 10px rgba(99,102,241,0.5)';
                                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                                    }}
                                                    onMouseLeave={e => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #6366f1, #4f46e5)';
                                                        e.currentTarget.style.boxShadow = '0 2px 6px rgba(99,102,241,0.4)';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                                    </svg>
                                                    Düzenle
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        <label>Cinsiyet / Yaş</label>
                                        <p>
                                            {viewDetailsApp.userGender === 'Male' ? 'Erkek' : viewDetailsApp.userGender === 'Female' ? 'Kadın' : viewDetailsApp.userGender}
                                            {viewDetailsApp.birthDate && ` / ${new Date().getFullYear() - new Date(viewDetailsApp.birthDate).getFullYear()} Yaş`}
                                        </p>
                                    </div>
                                    <div className="info-item">
                                        <label>Doğum Tarihi</label>
                                        <p>{viewDetailsApp.birthDate ? new Date(viewDetailsApp.birthDate).toLocaleDateString('tr-TR') : '-'}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Telefon</label>
                                        <p>{viewDetailsApp.phone}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Yedek Telefon</label>
                                        <p>{viewDetailsApp.phone2 || '-'}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>E-Posta</label>
                                        <p>{viewDetailsApp.email || '-'}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Meslek</label>
                                        <p>{viewDetailsApp.profession || '-'}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Tesis / Program</label>
                                        <p>{getProgramLabel(viewDetailsApp)}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Üyelik Süresi</label>
                                        <p>{viewDetailsApp.subscriptionDuration || '-'}</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Kayıt Tarihi</label>
                                        <p>{new Date(viewDetailsApp.createdDate).toLocaleString('tr-TR')}</p>
                                    </div>
                                    <div className="info-item full-width">
                                        <label>Ev Adresi</label>
                                        <div className="address-box">{viewDetailsApp.homeAddress || '-'}</div>
                                    </div>
                                    <div className="info-item">
                                        <label>Ödenen Ücret</label>
                                        <p className="highlight-price">{Number(viewDetailsApp.paidAmount || 0).toLocaleString('tr-TR')} ₺</p>
                                    </div>
                                    <div className="info-item">
                                        <label>Kart Numarası</label>
                                        <p>{viewDetailsApp.cardNumber || 'Atanmadı'}</p>
                                    </div>
                                </div>
                                <div style={{ marginTop: '20px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '10px' }}>
                                        <h4 style={{ margin: 0, color: '#0f172a', fontSize: '15px', fontWeight: 800 }}>Uyelik ve Kontorler</h4>
                                        <span style={{ color: '#64748b', fontSize: '12px', fontWeight: 700 }}>
                                            {getMemberships(viewDetailsApp).length} kayit
                                        </span>
                                    </div>

                                    {getMemberships(viewDetailsApp).length > 0 ? (
                                        <div style={{ display: 'grid', gap: '10px' }}>
                                            {getMemberships(viewDetailsApp).map((membership) => (
                                                <div
                                                    key={membership.id}
                                                    style={{
                                                        padding: '12px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #e2e8f0',
                                                        background: membership.status === 'Active' && membership.isCurrent ? '#f0fdf4' : '#f8fafc'
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap', marginBottom: '8px' }}>
                                                        <strong style={{ color: '#0f172a' }}>
                                                            {membership.programDisplayName || getProgramLabel(viewDetailsApp)} - {membership.planName}
                                                        </strong>
                                                        <span className="status-badge" style={getMembershipStatusStyle(membership)}>
                                                            {getMembershipStatusLabel(membership)}
                                                        </span>
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '8px', color: '#334155', fontSize: '13px' }}>
                                                        <span><strong>Toplam:</strong> {membership.totalCredits} kontor</span>
                                                        <span><strong>Kalan:</strong> {membership.remainingCredits} kontor</span>
                                                        <span><strong>Baslangic:</strong> {formatDate(membership.startDate)}</span>
                                                        <span><strong>Bitis:</strong> {formatDate(membership.endDate)}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div style={{ padding: '12px', borderRadius: '8px', background: '#f8fafc', border: '1px dashed #cbd5e1', color: '#64748b' }}>
                                            Bu kart icin uyelik paketi bulunmuyor.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="modal-actions">
                            <button className="btn-close" onClick={() => setViewDetailsApp(null)}>Kapat</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Full Screen Photo Viewer */}
            {fullScreenPhoto && (
                <div className="photo-viewer-overlay" onClick={() => setFullScreenPhoto(null)}>
                    <div className="photo-viewer-content" onClick={e => e.stopPropagation()}>
                        <button className="viewer-close" onClick={() => setFullScreenPhoto(null)}>&times;</button>
                        <img src={fullScreenPhoto} alt="Vesikalık" className="full-size-photo" />
                        <div className="viewer-actions">
                            <button
                                className="btn-download"
                                onClick={() => {
                                    let downloadBaseUrl = BASE_URL;
                                    if (!downloadBaseUrl.endsWith('/api')) downloadBaseUrl += '/api';
                                    const downloadUrl = `${downloadBaseUrl}/card/download-photo?url=${encodeURIComponent(fullScreenPhoto)}`;
                                    const a = document.createElement('a');
                                    a.href = downloadUrl;
                                    a.download = `Vesikalik_${viewDetailsApp?.identityNumber}.jpg`;
                                    a.target = '_blank';
                                    a.click();
                                }}
                            >
                                Fotoğrafı İndir
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Contact Modal */}
            {editContactApp && (
                <div className="premium-modal-overlay">
                    <div className="premium-modal contact-edit-modal">
                        <div className="modal-header">
                            <h3 className="modal-title">Kişi ve Kart Bilgilerini Düzenle</h3>
                            <span className="modal-subtitle">{editContactApp.firstName} {editContactApp.lastName}</span>
                            <button className="close-btn" onClick={() => setEditContactApp(null)}>&times;</button>
                        </div>

                        <div className="modal-body contact-edit-body">
                            <div className="input-group contact-edit-field">
                                <label>
                                    TC Kimlik Numarası
                                </label>
                                <input
                                    type="text"
                                    value={editIdentityNumber}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '').slice(0, 11);
                                        setEditIdentityNumber(value);
                                    }}
                                    placeholder="11 haneli TC kimlik numarası"
                                    maxLength={11}
                                />
                                <small>
                                    {editIdentityNumber.length}/11 karakter
                                </small>
                            </div>

                            <div className="input-group contact-edit-field">
                                <label>
                                    Telefon Numarası
                                </label>
                                <input
                                    type="text"
                                    value={editPhone}
                                    onChange={(e) => setEditPhone(e.target.value)}
                                    placeholder="Telefon numarası"
                                />
                            </div>

                            <div className="input-group contact-edit-field">
                                <label>
                                    Kart Numarası
                                </label>
                                <input
                                    type="text"
                                    value={editCardNumber}
                                    onChange={(e) => setEditCardNumber(e.target.value)}
                                    placeholder="000/0000000"
                                />
                            </div>

                            <div className="contact-edit-warning">
                                <p>
                                    <strong>Dikkat:</strong> Bu işlem kullanıcının TC, telefon ve kart bilgilerini kalıcı olarak değiştirecektir.
                                </p>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button 
                                className="btn-secondary" 
                                onClick={() => setEditContactApp(null)}
                                disabled={isUpdatingContact}
                            >
                                İptal
                            </button>
                            <button 
                                className="btn-primary" 
                                onClick={handleUpdateContact}
                                disabled={isUpdatingContact || editIdentityNumber.length !== 11 || !editPhone}
                            >
                                {isUpdatingContact ? 'Güncelleniyor...' : 'Güncelle'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CardApplicationsList;
